export default __webpack_public_path__ + "static/media/mod04.649787c6.svg";